export default __webpack_public_path__ + "static/media/3e.601c895a.png";